import * as actionTypes from "../actionTypes";

const initalState = {
  searchBar: "",
  stateValue: "",
  start_date: "",
  end_date: new Date().toJSON(),
  perPage: 50,
  page: 0,
  //THIS IS TO MAKE SURE THAT ONLY ONE REQUEST IS INITIATED
  allow_search: false,
};

export const searchReducer = (state = initalState, action) => {
  switch (action.type) {
    case actionTypes.ClientSideSearch.SEARCH_BAR:
      return {
        ...state,
        searchBar: action.payload,
      };
    case actionTypes.ClientSideSearch.STATE_BAR:
      return {
        ...state,
        stateValue: action.payload,
      };
    case actionTypes.ClientSideSearch.START_DATE:
      return {
        ...state,
        start_date: action.payload,
      };
    case actionTypes.ClientSideSearch.END_DATE:
      return {
        ...state,
        end_date: action.payload,
      };

    case actionTypes.ClientSideSearch.PER_PAGE:
      return {
        ...state,
        perPage: action.payload,
      };

    case actionTypes.ClientSideSearch.PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case actionTypes.ClientSideSearch.SEARCH_START:
      return {
        ...state,
        allow_search: action.payload,
      };
    default:
      return state;
  }
};
